/**
 *
 * Instantiation of Vue Router
 *
 * */

import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes.js'

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = `${to.meta && to.meta.title ? to.meta.title : 'Sapio App'}`

  if (SAPIO.Scenario.instance === undefined) SAPIO.Scenario.LS_GET()
  if (SAPIO.Game.instance === undefined) SAPIO.Game.LS_GET()
  if (SAPIO.Team.instance === undefined) SAPIO.Team.LS_GET()
  
  if (to.name === "preview") return next()
  else if (to.name === "game" && SAPIO.Game.instance !== undefined) return next()
  else if (to.name === "ranking" && SAPIO.Game.instance !== undefined) return next()
  else if (to.name !== "login" && SAPIO.Game.instance === undefined) return next({ path: '/login' })
  else if (to.name !== "login" && SAPIO.User.instance === undefined) return next({ path: '/login' })
  else return next()
})

Vue.use(VueRouter)

export default router